import { render, staticRenderFns } from "./formAdd.vue?vue&type=template&id=3f94c1f2&"
import script from "./formAdd.vue?vue&type=script&lang=js&"
export * from "./formAdd.vue?vue&type=script&lang=js&"
import style0 from "./formAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports